import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteAssetFeatureSaga,
  getAssetFeatureDetailsSaga,
  getAssetFeatureListSaga,
} from "src/store/asset-features/saga";
import {
  AssetFeatureDetailDto,
  AssetFeatureDto,
} from "src/store/asset-features/type";
import AssetFeatureCreateForm from "./create";
import AssetFeatureEditForm from "./edit";
const AssetFeaturePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<AssetFeatureDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<AssetFeatureDetailDto>();
  const columns = [
    {
      text: t("AssetFeature.AssetType"),
      dataField: "AssetTypeName",
    },
    {
      text: t("AssetFeature.DataType"),
      dataField: "DataTypeName",
    },
    {
      text: t("AssetFeature.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("AssetFeature.PageTitle")}
        metaTag={t("AssetFeature.MetaTag")}
        gridProps={{
          addTitle: t("AssetFeature.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getAssetFeatureListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getAssetFeatureDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          gridButtons(keyValue, data) {
            if (data.DataTypeId === 3) {
              return (
                <ColumnButton
                  buttonType={"custom"}
                  custombutton={{
                    text: t("AssetFeature.OptionsButton").toString(),
                  }}
                  onClick={() => navigate("/asset/features/options/" + data.Id)}
                />
              );
            }
          },
          deleteButton: {
            text: (id, data: AssetFeatureDto) =>
              t("AssetFeature.DeleteQA", {
                name: data.Name,
              }),
            action: deleteAssetFeatureSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <AssetFeatureCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getAssetFeatureListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <AssetFeatureEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getAssetFeatureListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default AssetFeaturePage;
